import axios from 'axios';
import { Freelancer, Project, MatchedResponse, User, UserProfile } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://renderspace-1.tailf10387.ts.net';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authService = {
  // Check if email already exists
  checkEmail: async (email: string): Promise<{ exists: boolean }> => {
    const response = await api.post('/auth/check-email', { email });
    return response.data;
  },

  // Register a new user
  register: async (userData: { email: string; name: string; userType: 'freelancer' | 'client'; password: string }): Promise<User> => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  // Login user
  login: async (credentials: { email: string; password: string }): Promise<{ user: User; token: string }> => {
    const response = await api.post('/auth/login', credentials);
    return { user: response.data, token: 'mock-token' }; // Backend returns user directly
  },

  // Get user profile
  getProfile: async (): Promise<UserProfile> => {
    // Get user from localStorage to get email
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      throw new Error('User not logged in');
    }
    const user = JSON.parse(userStr);
    
    const response = await api.get(`/auth/profile?email=${encodeURIComponent(user.email)}`);
    return response.data;
  },

  // Update user profile
  updateProfile: async (profile: UserProfile): Promise<UserProfile> => {
    const response = await api.put('/auth/profile', profile);
    return response.data;
  },
};

export const freelancerService = {
  // Register a new freelancer
  register: async (freelancer: any): Promise<User> => {
    const response = await api.post('/freelancers/register', freelancer);
    return response.data;
  },

  // Get all freelancers
  getAll: async (): Promise<Freelancer[]> => {
    const response = await api.get('/freelancers');
    return response.data;
  },
};

export const projectService = {
  // Match project to freelancers
  match: async (project: Project): Promise<MatchedResponse> => {
    const response = await api.post('/projects/match', project);
    return response.data;
  },

  // Create a new project
  create: async (projectData: any): Promise<any> => {
    const response = await api.post('/projects', projectData);
    return response.data;
  },

  // Get all projects
  getAll: async (): Promise<any[]> => {
    const response = await api.get('/projects');
    return response.data;
  },

  // Get a specific project by ID
  getById: async (projectId: string): Promise<any> => {
    const response = await api.get(`/projects/${projectId}`);
    return response.data;
  },

  // Get projects by client
  getByClient: async (clientEmail: string): Promise<any[]> => {
    const response = await api.get(`/projects/client/${encodeURIComponent(clientEmail)}`);
    return response.data;
  },

  // Update project status
  updateStatus: async (projectId: string, status: string): Promise<any> => {
    const response = await api.put(`/projects/${projectId}/status`, { status });
    return response.data;
  },
};

export default api; 